import { render } from "./DetailStockCard.vue?vue&type=template&id=770cae6c&scoped=true"
import script from "./DetailStockCard.vue?vue&type=script&lang=js"
export * from "./DetailStockCard.vue?vue&type=script&lang=js"

import "./DetailStockCard.vue?vue&type=style&index=0&id=770cae6c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-770cae6c"]])

export default __exports__